import { getTagTheme } from './tag/index.js';
import { getCardTheme } from './card/index.js';
import { getTableTheme } from './table/index.js';
import { getAlertTheme } from './alert/index.js';
import { getButtonTheme } from './button/index.js';
import { getDialogTheme } from './dialog/index.js';
import { getSpinnerTheme } from './spinner/index.js';
import { getDropdownTheme } from './dropdown/index.js';
import { getTimelineTheme } from './timeline/index.js';
import { getTaskFlowTheme } from './taskFlow/index.js';
import { getProgressTrackerTheme } from './progressTracker/index.js';
import { getSelectTheme } from './form/select.js';
import { getTextAreaTheme } from './form/textArea.js';
import { getCheckboxTheme } from './form/checkbox.js';
import { getTextInputTheme } from './form/textInput.js';
import { getDatePickerTheme } from './form/datePicker.js';
import { getRadioInputTheme } from './form/radioInput.js';
import { getMultiSelectTheme } from './form/multiSelect.js';
export { getTypographyTheme } from './typography/index.js';

/**
 * generate component themes
 */
var getComponentThemes = theme => {
  return {
    tag: getTagTheme(theme),
    card: getCardTheme(theme),
    table: getTableTheme(theme),
    alert: getAlertTheme(theme),
    button: getButtonTheme(theme),
    dialog: getDialogTheme(theme),
    select: getSelectTheme(theme),
    spinner: getSpinnerTheme(theme),
    taskFlow: getTaskFlowTheme(theme),
    progressTracker: getProgressTrackerTheme(theme),
    timeline: getTimelineTheme(theme),
    textArea: getTextAreaTheme(theme),
    dropdown: getDropdownTheme(theme),
    textInput: getTextInputTheme(theme),
    datePicker: getDatePickerTheme(theme),
    radioInput: getRadioInputTheme(theme),
    checkboxInput: getCheckboxTheme(theme),
    multiSelect: getMultiSelectTheme(theme)
  };
};
export { getComponentThemes };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
